module.exports = __webpack_public_path__ + "static/img/loading6.e8812278.gif";